import React, {
  ReactNode,
  useState,
  useImperativeHandle,
  forwardRef,
  useEffect,
  useRef,
} from "react";
import ReactDOM from "react-dom";
import classNames from "classnames";
import { View } from "@tarojs/components";
import { CSSTransition } from "react-transition-group";
import { XHComponentCommonProps } from "../../types";
import Mask from "../Mask";
import "./index.scss";

export type DialogProps = {
  header?: string | ReactNode;
  content: string | ReactNode;
  footer?: string | ReactNode;
  visible: boolean;
} & XHComponentCommonProps;

export type DialogRef = {
  close: () => void;
};
const DialogCom = forwardRef<DialogRef, DialogProps>((props, fromRef) => {
  const { header, content, footer, className = "", visible } = props;
  const [selfVisible, setSelfVisible] = useState(false);

  const nodeRef = useRef(null);

  useImperativeHandle(fromRef, () => ({
    close: () => {
      console.log("closes");
      setSelfVisible(false);
    },
  }));

  useEffect(() => {
    setSelfVisible(visible);
  }, [visible]);

  const dialogcls = classNames("xh-dialog", className, {
    microApp: process.env.TARO_ENV !== "h5",
  });

  const dialogContent = classNames("xh-dialog-content-content", {
    headless: !header,
  });
  const DialogMain = (
    <View className={dialogcls}>
      <Mask />
      <CSSTransition
        nodeRef={nodeRef}
        in={selfVisible}
        timeout={200}
        classNames="scale"
        unmountOnExit
      >
        <View className="xh-dialog-content">
          {header && <View className="xh-dialog-content-header">{header}</View>}
          <View className={dialogContent}>{content}</View>
          <View className="xh-dialog-content-footer">{footer}</View>
        </View>
      </CSSTransition>
    </View>
  );

  return ReactDOM.createPortal(DialogMain, document.body);
});

export default DialogCom;
